<!-- Main -->
<section id="main" class="wrapper">
    <div class="inner">
        <div class="content">
            <header><h4>Transaction Cancelled</h4></header>

           
            <div class="row">
                <div class="col-12-medium">   
                    
                    <h5>Your transaction has been successfully cancelled.</h5>
                    <p>If you wish to make a purchase, please use a different card.</p>
                    <p>The RRBootcamp Team</p>     

                        
                </div>                  
            </div>    

            <div class="col-12">
                <ul class="actions">
                    <li><input type="submit" value="Home" class="primary cancelBtn" routerLink="/home"></li>                      
                </ul>
            </div>
       
        </div>           
    </div>
</section>


